import React from 'react'
// import bg1 from '../assets/bg1.jpg'
// import Background from '../assets/bg1.jpg'
// import Products from './Product'
import Products from './Products'



const Home = () => {
  return (
    <div className="hero">
      <div className="card text-bg-dark border-0">
        <img src="https://www.ssi-schaefer.com/resource/blob/1076888/b5bdadcababc0904a574ea9d675870c3/e-commerce-hero-dam-image-en-31561--data.jpg" className="card-img" alt="Background" height="500px"/>
        <div className="card-img-overlay d-flex flex-column justify-content-center">
        <div className="container">

          <h5 className="card-title display-3 fw-bolder mb-0">NEW SEASON ARRIVALS</h5>
          <p className="card-text lead fs-2">
              CHECK OUT ALL THE TRAND 
          </p>
        </div>
       
        </div>
      </div>
      <Products/>
    </div>
  )
}

export default Home
